<app-header (closeEvent)="onCloseEvent($event)"></app-header>
    <div class="voxel-container-md container-padding">

        <app-stepper 
            *ngIf="CONTENT_BOUNDS && stepsList && stepsList.length > 0" 
            [title]="CONTENT_BOUNDS?.title" 
            [currentStep]="1" 
            [stepsList]="stepsList" 
            [labelName]="CONTENT_BOUNDS?.name" 
            [labelStep]="CONTENT_BOUNDS?.step">
        </app-stepper> 
        
        <div class="voxel-col-12" *ngIf="customerError?.value">
          <voxel-alert [type]="CONTENT_BOUNDS?.error_notification?.type" light class="voxel-mb-2"
              [icon]="CONTENT_BOUNDS?.error_notification?.icon">
              {{CONTENT_BOUNDS?.error_notification?.text}}
          </voxel-alert>
        </div>
        <app-solicitation-modal-typification #modalTypification [formGroup]="basicDataForm" [componentStart]="true"></app-solicitation-modal-typification>               
        <app-steps-information-modal #modalStepsInformation [formGroup]="basicDataForm"></app-steps-information-modal>
        <div class="container-data">
            <app-form-solicitation-basic-data #formBasic (findClient)="findClient($event)" [formGroup]="basicDataForm"
                [data]="solicitationData?.basicData"></app-form-solicitation-basic-data>
                
            <app-form-solicitation-contacts-data *ngIf="!formBasic?.isLoading && basicDataForm.valid" [formGroup]="contactsDataForm" [data]="solicitationData" ></app-form-solicitation-contacts-data>

            <app-terms-conditions-modal #modalTermsConditions [formGroup]="termsForm" [componentStart]="true"></app-terms-conditions-modal>
        </div>
        <ng-container *ngIf="customerLoaded?.value">
          <div class="voxel-col-12" *ngIf="!customerExists?.value">
              <voxel-alert [type]="CONTENT_BOUNDS?.not_found_notification?.type" light class="voxel-mb-2"
                  [icon]="CONTENT_BOUNDS?.not_found_notification?.icon">
                  {{CONTENT_BOUNDS?.not_found_notification?.text}}
              </voxel-alert>
          </div>
        </ng-container>
        <div class="actions" *ngIf="form">
            <div class="voxel-row">
                <button
                    [disabled]="formBasic?.isLoading"
                    voxelButton
                    buttonStyle=secondary
                    (click)="navigateTo('previous')"
                    class="voxel-col-12 voxel-col-xs-2 voxel-col-offset-sm-2 voxel-col-sm-3 voxel-col-offset-md-3 voxel-col-md-4">
                    {{CONTENT_BOUNDS?.buttons?.secondary_button?.caption}}
                </button>
                <button voxelButton (click)="navigateTo('next')"
                    class="voxel-col-12 voxel-col-xs-2 voxel-col-sm-3 voxel-col-md-4"
                    [disabled]="!form?.valid || formBasic?.isLoading">
                    {{CONTENT_BOUNDS?.buttons?.primary_button?.caption}}
                </button>
            </div>
        </div>
    </div>    
